__webpack_require__.p = "/ch/de/customer-service/returns-claims/spareparts/";